import { z } from 'zod';

/** Лимиты свободной бизнес-карты. Пустая строка на входе становится null. */
export const BIO_ROLE_MAX = 100;
export const BIO_SKILLS_MAX = 250;
export const BIO_INDUSTRY_MAX = 150;
export const BIO_REQUEST_MAX = 250;

/**
 * Необязательный текст. Ключ можно не присылать (поле не трогаем).
 * `null` и строка из пробелов стирают значение.
 */
export function optionalBlankText(max: number) {
  return z
    .string()
    .trim()
    .max(max)
    .nullable()
    .transform((value): string | null => (value == null || value.length === 0 ? null : value))
    .optional();
}

export const BusinessCardTextDto = z.object({
  bioRole: z.string().nullable(),
  bioSkills: z.string().nullable(),
  bioIndustry: z.string().nullable(),
  bioRequest: z.string().nullable(),
});
export type BusinessCardTextDto = z.infer<typeof BusinessCardTextDto>;

export const EMPTY_BUSINESS_CARD: BusinessCardTextDto = {
  bioRole: null,
  bioSkills: null,
  bioIndustry: null,
  bioRequest: null,
};

/**
 * Снимок бизнес-карты: четыре текста и четыре набора тегов. Все поля
 * необязательны — источником бывает и строка Prisma, и DTO, и патч.
 */
export interface BusinessCardContentSource {
  bioRole?: string | null | undefined;
  bioSkills?: string | null | undefined;
  bioIndustry?: string | null | undefined;
  bioRequest?: string | null | undefined;
  roleTags?: readonly string[] | undefined;
  skillTags?: readonly string[] | undefined;
  industryTags?: readonly string[] | undefined;
  requestTags?: readonly string[] | undefined;
}

/**
 * Карта заполнена: непусто хотя бы одно из восьми полей.
 *
 * Это порог готовности ДЕЛОВОГО режима вместо прежних «трёх сфер»: сферы —
 * теги каталога знакомств, форма их больше не показывает, и требовать их
 * значило бы навсегда закрыть деловую выдачу новым анкетам.
 */
export function hasBusinessCardContent(card: BusinessCardContentSource): boolean {
  const texts = [card.bioRole, card.bioSkills, card.bioIndustry, card.bioRequest];
  if (texts.some((value) => (value?.trim() ?? '').length > 0)) return true;
  const tags = [card.roleTags, card.skillTags, card.industryTags, card.requestTags];
  return tags.some((list) => (list?.length ?? 0) > 0);
}
